import { render, staticRenderFns } from "./AssessmentValue.vue?vue&type=template&id=6fddc05f&"
import script from "./AssessmentValue.vue?vue&type=script&lang=js&"
export * from "./AssessmentValue.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentValue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports